export const inactiveSourceLayers = {
  flowingWater: {
    'line-color': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      '#217F9A',
      '#657F8C',
    ],
    'line-opacity': 0.65,
    'line-dasharray': [4, 4],
    'line-width': 2,
  },
  stillWater: {
    'fill-color': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      '#217F9A',
      '#657F8C',
    ],
    'fill-opacity': 0.35,
  },
  stillWaterOutline: {
    'line-color': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      '#217F9A',
      '#657F8C',
    ],
    'line-opacity': 0.65,
    'line-dasharray': [4, 4],
    'line-width': 2,
  },
  rwzi: {
    'circle-color': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      '#217F9A',
      '#657F8C',
    ],
    'circle-opacity': 0.65,
    'circle-stroke-color': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      '#217F9A',
      '#657F8C',
    ],
    'circle-stroke-opacity': 0.65,
  },
};
